module.exports = __webpack_public_path__ + "static/clinica-lar-513077d9a74cb7debee21cf82ac4b3b2.png";